<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header">
    <span class="modal-title h4" [innerHTML]="'main.modals.passwordExpiration.title' | translate"></span>

    <button aria-label="Close" data-dismiss="modal" class="close" type="button" (click)="activeModal.dismiss('closed')">
       <span aria-hidden="true">{{'main.charX' | translate}}</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12 mb-4" 
        [innerHTML]="'main.modals.passwordExpiration.description' | translate : {value: expirationDays}">
                avviso descrizione
        </div>
        <div class="col-md-12">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="disableAdv" [(ngModel)]="checkbox">
                <label class="custom-control-label" for="disableAdv" 
                [innerHTML]="'main.modals.passwordExpiration.checkboxLabel' | translate"></label>
              </div>
        </div>
    </div>
</div>
<div class="modal-footer justify-content-start">
    <button type="submit" class="btn btn-lg btn-primary"  
        [innerHTML]="'main.modals.passwordExpiration.btnChangePwd' | translate" (click)="hideAdvise(true)"></button>
    <button type="button" class="btn btn-link" (click)="hideAdvise(false)" 
        [innerHTML]="'main.modals.passwordExpiration.btnCancel' | translate"></button>
</div>